import { object, string } from "yup";

import { translate } from "utils/translations/translate";

const validationSchema = object().shape({
  email: string()
    .email(translate.t("validations.email"))
    .required(translate.t("validations.required")),
  /*
   * The forbidden characters (e.g. =,'',"") check
   * will still be performed by the old custom
   * method via field-level validation
   */
  role: string().required(translate.t("validations.required")),
});

export { validationSchema };
